import { css } from '@emotion/react';
import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonPage,
  IonRow,
  IonText,
} from '@ionic/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import OopsImg from '../../assets/img/oops.svg?react';
import * as commonCss from '../../styles/common';
import PageHeader from '../PageHeader';
import { Title } from '../Title';

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorFallbackCss = {
  outerContainer: [
    css({
      padding: '1rem',
    }),
  ],
  card: css({
    margin: 'auto',
    maxWidth: '500px',
  }),
  centeredText: css({
    textAlign: 'center',
  }),
  attribution: css({
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    bottom: 0,
  }),
};

const ErrorFallback: React.FC = () => (
  <IonPage>
    <PageHeader title="Oops!" />
    <IonContent>
      <div css={ErrorFallbackCss.outerContainer}>
        <IonCard css={ErrorFallbackCss.card}>
          <IonCardHeader>
            <IonCardTitle>
              <Title level={1}>Something went wrong...</Title>
            </IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <IonGrid>
              <IonRow>
                <IonCol size="12" css={ErrorFallbackCss.centeredText}>
                  <OopsImg />
                  <div css={ErrorFallbackCss.attribution}>
                    <IonButton fill="clear" size="small" href="https://storyset.com/home" target="_blank">
                      <IonText css={commonCss.extraSmallText}>Home illustrations by Storyset</IonText>
                    </IonButton>
                  </div>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol css={ErrorFallbackCss.centeredText}>
                  <Title level={2}>
                    Our team has been alerted to this issue.
                    <br />
                    Please, try again later.
                  </Title>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardContent>
        </IonCard>
      </div>
    </IonContent>
  </IonPage>
);

const SentryErrorBoundary: React.FC<SentryErrorBoundaryProps> = ({ children }) => {
  return <Sentry.ErrorBoundary fallback={<ErrorFallback />}>{children}</Sentry.ErrorBoundary>;
};

export default SentryErrorBoundary;
